/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from "styled-components";
import { FontWeight } from "components/Text";
import { mediaHelper } from "../../utils/src";
import globalStyles from "globalStyles";
import { Label } from "@fitinsur/components";

export const Content = styled.div`
  padding: 10px 0 0;
`;

export const Text = styled.text`
  display: block;
  color: ${globalStyles.components.brokingSummary.text};
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 14px;
  margin-bottom: 5px;

  ${mediaHelper.sm`
    font-size: 16px;
  `}
`;

export const CustomLabel = styled(Label)`
  display: block;
  color: ${globalStyles.components.brokingSummary.label};
  font-weight: ${FontWeight.Bold};
  font-size: 12px;

  ${mediaHelper.sm`
    font-size: 14px;
  `}
`;
